import * as base from 'store/bolt/header.js';
import Store from 'store/store';

Store.on('THANK_YOU_SHOWN', (bool) => {
	Store.get().header.set({
		thankYouScreenShown: bool
	});
});

